<template>
	<div class="content" >
		<div  id="mainRepoart">
			<!-- <el-table :data="tabledata1"  border   :header-cell-style="headerCelStyle" v-loading="loading" :span-method="objectSpanMethod">
				<el-table-column type="index" align='center' width="60" label="序号"></el-table-column>
				<el-table-column prop="ydbSheng" align='center' label="省"></el-table-column>
				<el-table-column prop="ydbShi" align='center' label="市"></el-table-column>
				<el-table-column prop="ydbXian" align='center' label="县"></el-table-column>
				<el-table-column prop="mobile" align='center' label="管理单位、坝">
					<el-table-column prop="ydbXiang" align='center' ></el-table-column>
					<el-table-column prop="ydbName" align='center' ></el-table-column>
					<el-table-column prop="ydbLx" align='center' ></el-table-column>
				</el-table-column>
					<el-table-column prop="ydbJcsx" align='center' label="检查事项"></el-table-column>
					<el-table-column prop="ydbJcxm" align='center' label="检查项目或对象"></el-table-column>
					<el-table-column prop="ydbWtms" align='center' label="问题描述"></el-table-column>
					<el-table-column prop="ydbFj" align='center' label="附件序号"></el-table-column>
					<el-table-column prop="ydbWtxh" align='center' label="问题序号"></el-table-column>
					<el-table-column prop="ydbWtfj" align='center' label="问题分级"></el-table-column>
					<el-table-column prop="" align='center' label="整改情况"></el-table-column>


				<el-table-column align='center' label="责任追究情况">
					<el-table-column prop="ydbZrdw" align='center' label="责任单位"></el-table-column>
					<el-table-column prop="ydbZrrzjfs" align='center' label="追究方式"></el-table-column>
					<el-table-column prop="ydbZrr" align='center' label="责任人"></el-table-column>
					<el-table-column prop="ydbZrrzjfs" align='center' label="追究方式"></el-table-column>
				</el-table-column>
			</el-table> -->

			<vxe-table style="width:calc(100% - 40px)" ref="xTable" border  :print-config="{}" :export-config="tableExport"  :data="tabledata" :height="tableHeight" :header-cell-style="headerCelStyle" >
				<!-- <vxe-table-column type="seq" width="60"></vxe-table-column>
				<vxe-table-column field="pointDesignNumber" title="测点编号" footer-align="center" align="center"></vxe-table-column>
				<vxe-table-column field="typeName" title="仪器名称" footer-align="center" align="center"></vxe-table-column>
				<vxe-table-column field="physicalName" title="物理量类型" footer-align="center" align="center"></vxe-table-column>
				<vxe-table-column field="physicalUnit" title="单位" footer-align="center" align="center"></vxe-table-column>
				<vxe-table-column field="cezhi" title="测值" footer-align="center" align="center"></vxe-table-column> -->

				<vxe-table-column type="seq" align='center' width="60" title="序号"></vxe-table-column>
				<vxe-table-column field="ydbSheng" align='center' title="省"></vxe-table-column>
				<vxe-table-column field="ydbShi" align='center' title="市"></vxe-table-column>
				<vxe-table-column field="ydbXian" align='center' title="县"></vxe-table-column>
				<vxe-table-colgroup  field="mobile" align='center' title="管理单位、坝">
					<vxe-table-column field="ydbXiang" align='center' ></vxe-table-column>
					<vxe-table-column field="ydbName" align='center' ></vxe-table-column>
					<vxe-table-column field="ydbLx" align='center' ></vxe-table-column>
				</vxe-table-colgroup >
				<vxe-table-column field="ydbJcsx" align='center' title="检查事项"></vxe-table-column>
				<vxe-table-column field="ydbJcxm" align='center' title="检查项目或对象"></vxe-table-column>
				<vxe-table-column field="ydbWtms" align='center' title="问题描述"></vxe-table-column>
				<vxe-table-column field="ydbFj" align='center' title="附件序号"></vxe-table-column>
				<vxe-table-column field="ydbWtxh" align='center' title="问题序号"></vxe-table-column>
				<vxe-table-column field="ydbWtfj" align='center' title="问题分级"></vxe-table-column>
				<vxe-table-column field="ydbZgqk" align='center' title="整改情况"></vxe-table-column>
				<vxe-table-colgroup  align='center' title="责任追究情况">
					<vxe-table-column field="ydbZrdw" align='center' title="责任单位"></vxe-table-column>
					<vxe-table-column field="ydbZrrzjfs" align='center' title="追究方式"></vxe-table-column>
					<vxe-table-column field="ydbZrr" align='center' title="责任人"></vxe-table-column>
					<vxe-table-column field="ydbZrrzjfs" align='center' title="追究方式"></vxe-table-column>
				</vxe-table-colgroup >

			</vxe-table>
		</div>
		<!-- <el-dialog
			title="打印"
			:visible.sync="dialogVisible"
			width="30%"
			:before-close="handleClose">
			<span>确定打印吗</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sureToPrint">确 定</el-button>
			</span>
		</el-dialog> -->
	</div>
</template>
<script>
	// import printJS from "print-js";
	import {searchSpyOn} from "@/api/api";
	export default {
		data() {
			return {
				loading:true,dialogVisible:false,
				tableHeight: window.innerHeight - 40,
				tabledata: [],tabledata1:[],
				total:"",
				tableExport: {
					// 默认选中类型
					type: "xlsx",
					// 自定义类型
					//types: ['xlsx', 'csv', 'html', 'xml', 'txt']
				},
			}
		},
		mounted() {
			this.list({...this.$route.query})
			
		},
		methods: {
			handleClose(){
				this.dialogVisible = false
			},
			sureToPrint(flag){
				if(flag == 1){
					this.$refs.xTable.exportData({
						filename: '暗访督查',
						sheetName: "Sheet1",
						type: "xlsx",
					});
				}else if(flag == 2){
					this.$refs.xTable.print();
				}
      			
    
				// 	printable:'mainRepoart',
				// 	type:'html',
				// 	// header:'<p class="custom-p">位移统计表</p>',
				// 	// style:'.custom-p {width:500px}',
				// 	targetStyles:['*'],
				// 	ignoreElements:['no-print','bc','gb']
				// })
			},
			headerCelStyle({ row, column, rowIndex, columnIndex }) {
				if(column.title == '管理单位、坝'){
					column.colSpan = 3;
				}else if(column.title == ''){
					column.colSpan = 0;
					column.rowSpan = 0;
				}
				// if()

				if (rowIndex === 1  && (columnIndex == 0|| columnIndex == 1 || columnIndex == 2 )) {
					return 'display:none'
				}else{
					return 'background:rgba(49,130,222,0.1)'
				}

			},
			// 表格合并
			objectSpanMethod({ row, column, rowIndex, columnIndex }) {
				if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 ) {
					if (rowIndex  === 0) {
						return {
							rowspan: this.total,  //第一列一直到底  todo:要考虑到不同的区
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}else{  //第四列
					if ((row.ydbXiang  === '省市县责任落实' || row.ydbXiang === '乡镇级责任落实') && columnIndex === 4) {  //第一个空
						return {
							rowspan: 1,
							colspan: 3
						};
					} else if ((row.ydbName  === '省市县责任落实' || row.ydbName === '乡镇级责任落实' || row.ydbLx  === '省市县责任落实' || row.ydbLx === '乡镇级责任落实') && ( columnIndex === 5 || columnIndex === 6)){ //第二第三
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},
			list(params){
				searchSpyOn(params).then((res)=>{
					this.total = res.data.length
					this.tabledata = res.data;
					this.loading = false
					var that = this
					setTimeout(function(){
						that.sureToPrint(params.flag)
					},200)
				})
				
			},
		
		}
	}
</script>

<style scoped>
	@import url('../../common/css/mangementall.css');
	.content{
		overflow: auto;
		padding: 20px;
	}
</style>